export default "__VITE_ASSET__R57$g8fS__"